var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import tinycolor from "tinycolor2";
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  line-height: 16px;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 14px 24px 10px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  &:hover {\n    background-color: ", ";\n\n  }\n  &:disabled {\n    background-color: ", ";\n    cursor: not-allowed;\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"], ["\n  color: ",
    ";\n  font-family: ", ";\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n  line-height: 16px;\n  background-color: ",
    ";\n  border-radius: ", ";\n  padding: 14px 24px 10px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  &:hover {\n    background-color: ",
    ";\n\n  }\n  &:disabled {\n    background-color: ", ";\n    cursor: not-allowed;\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.colors.textAlt2
        : theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamilies.ffMain;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? theme.colors.accent4
        : theme.colors.accent1;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, function (_a) {
    var theme = _a.theme;
    return theme.name === "default"
        ? tinycolor(theme.colors.accent4).lighten(5).toString()
        : tinycolor(theme.colors.accent1).lighten(5).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightText;
});
var templateObject_1;
//# sourceMappingURL=Button.js.map